// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 319) return "static/chunks/319-eccb046cf22dc242.js";
	if (chunkId === 3226) return "static/chunks/3226-7c6ee46cb2f6ba1b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3899":"c2c15b1d313f0186","5791":"5e8c918f51d44845","6280":"95c0e1f2c52a9990","8172":"aef7dce4e531163b"}[chunkId] + ".js";
};